import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../slices/thunks';
import { useLocation, Link } from 'react-router-dom';
import { Row, Col, Alert, Card, CardBody, Container, Input, Label, Form } from "reactstrap";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from './ParticlesAuth';

const ResetPasswordForm = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [newPassword, setNewPassword] = useState('');
    const resetSuccessMsg = useSelector((state) => state.ForgetPassword.resetSuccessMsg);
    const resetError = useSelector((state) => state.ForgetPassword.resetError);

    const [token, setToken] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tokenParam = params.get('token');
        if (tokenParam) {
            setToken(tokenParam);
        }
    }, [location]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(resetPassword({ token, password: newPassword }));

    };

    return (
        <>
            <ParticlesAuth />
            <div className="auth-page-content  mt-lg-5">
                <Row>
                    <Col lg={12}>
                        <div className="text-center mt-sm-5 mb-4 text-white-50">
                            <div>
                                <Link to="/#" className="d-inline-block auth-logo">
                                    <img src={logoLight} alt="" height="100" />
                                </Link>
                            </div>

                        </div>
                    </Col>
                </Row>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    <h5 className="text-primary text-center">Reset Password</h5>
                                    <Alert className="border-0 text-center mb-2 mx-2" role="alert">
                                        Please enter your new password.
                                    </Alert>
                                    <div className="p-2">
                                        {resetError && (
                                            <Alert color="danger" style={{ marginTop: "13px" }}>
                                                {resetError}
                                            </Alert>
                                        )}
                                        {resetSuccessMsg && (
                                            <Alert color="success" style={{ marginTop: "13px" }}>
                                                {resetSuccessMsg}
                                            </Alert>
                                        )}
                                        <Form onSubmit={handleSubmit}>
                                            <div className="mb-4">
                                                <Label className="form-label">New Password</Label>
                                                <Input
                                                    type="password"
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    placeholder="Enter your new password"
                                                    required
                                                />
                                            </div>
                                            <div className="text-center mt-4">
                                                <button className="btn btn-success w-100" type="submit">
                                                    Reset Password
                                                </button>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="mt-4 text-center">
                                <p className="mb-0">
                                    Remembered your password?
                                    <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default ResetPasswordForm;
